import type { NavItem } from '@/components/layout/Sidebar';

export const NAV_FAVORITES_KEY = 'fattah_nav_favorites_v1';
export const NAV_FAVORITES_LIMIT = 8;

export function readFavoritePaths(): string[] {
  try {
    const raw = localStorage.getItem(NAV_FAVORITES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.filter((p): p is string => typeof p === 'string') : [];
  } catch {
    return [];
  }
}

export function toggleFavoritePath(path: string): string[] {
  const current = readFavoritePaths();
  const exists = current.includes(path);
  const next = exists
    ? current.filter((p) => p !== path)
    : [path, ...current].slice(0, NAV_FAVORITES_LIMIT);
  localStorage.setItem(NAV_FAVORITES_KEY, JSON.stringify(next));
  return next;
}

export function resolveNavItemsByPaths(paths: string[], allItems: NavItem[]): NavItem[] {
  const byPath = new Map(allItems.map((item) => [item.to, item]));
  return paths.map((path) => byPath.get(path)).filter((item): item is NavItem => Boolean(item));
}
